import React from 'react'
import { withRouter } from 'react-router-dom'
import { Row, Col, Steps, Divider, Form, Button, message } from 'antd'

import fileDownloadService from './../services/file.download.service'
import joinusService from './../services/joinus.service'
import JoinUsPositionStep from '../wizard/join-us/JoinUsPositionStep'
import JoinUsProfileContactStep from '../wizard/join-us/JoinUsProfileContactStep'
import JoinUsMainExperiencePositionStep from '../wizard/join-us/JoinUsMainExperiencePositionStep'
import JoinUsCandidateExperienceDetailsStep from '../wizard/join-us/JoinUsCandidateExperienceDetailsStep'
import JoinUsSupportingDocumentsStep from '../wizard/join-us/JoinUsSupportingDocumentsStep'
import PublicLayout from '../layout/PublicLayout'

const { Step } = Steps

class JoinUsView extends React.Component {
  state = {
    currentStep: 0,
    toLandingPage: false,
    profile: null,
    fileCV: null,
    fileCL: null,
    positions: [],
  }

  componentDidMount() {
    this.getData()
  }

  getData = async () => {
    const [positions, profile] = await Promise.all([
      await joinusService.getPositions(),
      await joinusService.getLastProfile(),
    ])
    const fileCV = profile.fileCV
    const fileCL = profile.fileCL
    this.setState({ profile, positions, fileCV, fileCL })
  }

  getProfile = async () => {
    const profile = await joinusService.getLastProfile()
    if (profile.message) profile.isRegistered = true
    this.setState({ profile })
  }

  next = () => {
    if (this.state.currentStep === 3) {
      this.props.form.validateFieldsAndScroll(['file'], (err, values) => {
        if (!err) {
          const currentStep = this.state.currentStep + 1
          this.setState({ currentStep })
        }
      })
    } else {
      const currentStep = this.state.currentStep + 1
      this.setState({ currentStep })
    }
  }

  prev = () => {
    const currentStep = this.state.currentStep - 1
    this.setState({ currentStep })
  }

  handleStepsClick = (step) => {
    this.setState({
      currentStep: step,
    })
  }

  handleFileUploads = (file, type) => {
    let newProfile = this.state.profile
    newProfile[type] = file

    this.setState({
      [type]: file,
      profile: newProfile,
    })
  }

  handleFileDownload = async (fileName, fileId, fileType) => {
    await fileDownloadService.download(
      `/api/v1/joinus/file/download?fileId=${fileId}&fileType=${fileType}`,
      fileName,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'same-origin',
      }
    )
  }

  handleSave = async (e) => {
    e.preventDefault()

    this.props.form.validateFieldsAndScroll(async (err, values) => {
      if (!err) {
        values['_id'] = this.state.profile ? this.state.profile._id : null
        values['extId'] = this.state.profile ? this.state.profile.extId : null
        values['fileCVId'] = this.state.fileCV ? this.state.fileCV._id : null
        values['fileCLId'] = this.state.fileCL ? this.state.fileCL._id : null
        values['createdBy'] = this.state.profile
          ? this.state.profile.createdBy
          : null
        values['creationDate'] = this.state.profile
          ? new Date(this.state.profile.creationDate)
          : new Date()
        values['recruitId'] = ''
        console.log('Received values of form: ', values)
        await joinusService.saveRecruitment(values)
        await this.getProfile()
        message.success('Your profile has been saved')
      } else {
        message.error('Missing required fields!')
      }
    })
  }

  handleSubmit = async (e) => {
    e.preventDefault()

    this.props.form.validateFieldsAndScroll(async (err, values) => {
      if (!err) {
        values['_id'] = this.state.profile ? this.state.profile._id : null
        values['extId'] = this.state.profile ? this.state.profile.extId : null
        values['fileCVId'] = this.state.fileCV ? this.state.fileCV._id : null
        values['fileCLId'] = this.state.fileCL ? this.state.fileCL._id : null
        values['createdBy'] = this.state.profile
          ? this.state.profile.createdBy
          : null
        values['creationDate'] = this.state.profile
          ? new Date(this.state.profile.creationDate)
          : new Date()
        values['recruitId'] = ''
        console.log('Received values of form: ', values)
        await joinusService.submitRecruitment(values)
        this.props.history.push('/thankyou')
      } else {
        message.error('Missing required fields!')
      }
    })
  }

  render() {
    const { currentStep, profile, positions } = this.state

    const steps = [
      {
        title: 'Select Position',
        content: (
          <JoinUsPositionStep
            form={this.props.form}
            profile={profile}
            positions={positions}
          />
        ),
      },
      {
        title: 'Profile & Contact Information',
        content: (
          <JoinUsProfileContactStep form={this.props.form} profile={profile} />
        ),
      },
      {
        title: 'Main Experience & Position',
        content: (
          <JoinUsMainExperiencePositionStep
            form={this.props.form}
            profile={profile}
          />
        ),
      },
      {
        title: 'Candidate Experience and Details',
        content: (
          <JoinUsCandidateExperienceDetailsStep
            form={this.props.form}
            profile={profile}
          />
        ),
      },
      {
        title: 'Supporting Documents',
        content: (
          <JoinUsSupportingDocumentsStep
            form={this.props.form}
            profile={profile}
            handleFileUploads={this.handleFileUploads}
            handleFileDownload={this.handleFileDownload}
          />
        ),
      },
    ]

    const formItemLayout = {
      layout: 'horizontal',
      labelAlign: 'right',
    }

    return (
      <section id="join-us-view">
        <Row>
          <Col span={20} offset={2}>
            <Steps
              size="default"
              labelPlacement="vertical"
              current={currentStep}
            >
              <Step
                title="Select Position"
                onClick={() => this.handleStepsClick(0)}
              />
              <Step
                title="Profile & Contact Information"
                onClick={() => this.handleStepsClick(1)}
              />
              <Step
                title="Main Experience & Position"
                onClick={() => this.handleStepsClick(2)}
              />
              <Step
                title="Candidate Experience and Details"
                onClick={() => this.handleStepsClick(3)}
              />
              <Step
                title="Supporting Documents"
                onClick={() => this.handleStepsClick(4)}
              />
            </Steps>
          </Col>
          <Col span={20} offset={2}>
            <Divider />
          </Col>
          <Col span={16} offset={4}>
            <section id="join-us-form">
              <Form
                {...formItemLayout}
                onSubmit={
                  this.state.currentStep === steps.length - 1
                    ? this.handleSubmit
                    : this.handleSave
                }
              >
                {steps.map(({ title, content }, i) => (
                  <div
                    key={title}
                    className={
                      i === this.state.currentStep ? 'fade-in' : 'hide'
                    }
                  >
                    {content}
                  </div>
                ))}
                <div className="steps-action">
                  {this.state.currentStep < 4 && (
                    <Button type="primary" htmlType="submit">
                      Save
                    </Button>
                  )}
                  {this.state.currentStep === steps.length - 1 && (
                    <Button type="primary" htmlType="submit">
                      Submit
                    </Button>
                  )}

                  <div>
                    {this.state.currentStep > 0 && (
                      <Button onClick={this.prev}>Previous</Button>
                    )}
                    {this.state.currentStep < steps.length - 1 && (
                      <Button
                        type="primary"
                        onClick={this.next}
                        style={{ marginLeft: 8 }}
                      >
                        Next
                      </Button>
                    )}
                  </div>
                </div>
              </Form>
            </section>
          </Col>
        </Row>
      </section>
    )
  }
}

const JoinUs = () => {
  const JoinUsForm = withRouter(Form.create({})(JoinUsView))
  return (
    <PublicLayout>
      {' '}
      <JoinUsForm />{' '}
    </PublicLayout>
  )
}

export default JoinUs
